/*global FakeCation*/
(function (FC) {
  "use strict";

  FC.utils.registerBlender('gaussianblur', function (imgData, background, cb, config) {
    var tmpCanvas = document.createElement('canvas'),
      ctx,
      image = document.createElement('canvas'),
      scale = config.scale || 1,
      left,
      right,
      bottom,
      top;

    image.width = imgData.width;
    image.height = imgData.height;
    tmpCanvas.width = background.width;
    tmpCanvas.height = background.height;

    left = (config.left || 0) -5;
    right = left + image.width * scale;

    bottom = tmpCanvas.height + (config.bottom || 0) + 5;
    top = bottom - image.height * scale;

    console.log(tmpCanvas.width, tmpCanvas.height);
    console.log(image.width, image.height);

    /* TODO
    var px = imgData.data;

    for (var j = 0; j < 2; j++) {
      var tmpPx = new Uint8ClampedArray(px);

      for (var i = 0, len = px.length; i < len; i++) {
        if (i % 4 === 3) {
          continue;
        }

        px[i] = (tmpPx[i] + (tmpPx[i - 4] || tmpPx[i]) + (tmpPx[i + 4] || tmpPx[i]) + (tmpPx[i - 4 * imgData.width] || tmpPx[i]) + (tmpPx[i + 4 * imgData.width] || tmpPx[i]) + (tmpPx[i - 4 * imgData.width] - 4 || tmpPx[i]) + (tmpPx[i + 4 * imgData.width] + 4 || tmpPx[i]) + (tmpPx[i - 4 * imgData.width] + 4 || tmpPx[i]) + (tmpPx[i + 4 * imgData.width] - 4 || tmpPx[i])) / 9;
      }
      j++;
    }
    */

    image.getContext('2d').putImageData(imgData, 0, 0);

    ctx = tmpCanvas.getContext('2d');

    ctx.globalCompositeOperation = 'source-over'; // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation

    ctx.drawImage(background, 0, 0);
    ctx.drawImage(image, left, top, right - left, bottom - top);

    cb(ctx.getImageData(0, 0, tmpCanvas.width, tmpCanvas.height));
  });
}(FakeCation));
